import React from "react";
import FieldDropDown from "../../../shared/controls/fieldDropDown";
import FieldCalendar from "../../../shared/controls/fieldCalendar";
import produce from "immer";
import ButtonIcon from "../../../shared/controls/ButtonIcon";
import constantes from "../../constantes";
import DateFormatter from "../../../shared/ag-grid-helper/dateFormatter";
import FieldMultiSelect from "../../../shared/controls/fieldMultiSelect";
import InputFile from "../../../shared/controls/inputFile";
import FieldTextBox from "../../../shared/controls/fieldTextBox";
import ReadOnlyProvider from "../../../shared/forms/ReadOnlyProvider";
import useSeguridad from "../../../Seguridad/useSeguridad";
import moment from "moment";
const Historial = ({ historial, antidoping,antidopingExterno, onChange, errors, actasAdministrativas, recursosConfiables, soloLectura, permisoHistorialEmpleados, bitacora }) => {
    const seguridad = useSeguridad();
    const permisoActasAdministrativas = seguridad.tieneAcceso(constantes.opciones.permisosActasAdm);
    const permisoHistorialOcultar = seguridad.tieneAcceso(constantes.opciones.permisoOcultarHistorial);
    const permisoIDSE = seguridad.tieneAcceso(constantes.opciones.permisosubirIDSE);
    function actualizarLista(lista, index, value, propertyName, namelist) {
        const nuevo = produce(lista, draft => {
            draft[index][propertyName] = value;
        }
        );

        onChange(nuevo, namelist);
    }
    console.log(permisoIDSE)
    function agregarALista(lista, namelist) {
        console.log('adad')
        const nuevo = produce(lista, draft => {
            draft.splice(0, 0, {});
        }
        );
        onChange(nuevo, namelist);
    }

    function eliminarDeLista(lista, index, namelist) {
        const nuevo = produce(lista, draft => {
            draft.splice(index, 1);
        }
        );

        onChange(nuevo, namelist);
    }

    function agregarBitacora() {
        let fecha = new Date();
        fecha.setMonth(fecha.getMonth() + 1);

        const newItem = {
            id: 0,
            descripcion: 'Entrega de Bitacora',
            vigencia: fecha
        }
        const newValue = produce(bitacora, (draft) => {
            draft.push(newItem);
        });

        onChange(newValue, 'empleadoBitacoras');
    };

    return (
        <ReadOnlyProvider defaultReadOnly={soloLectura && !permisoHistorialEmpleados}>
      {(permisoIDSE || permisoHistorialOcultar) && (
    <>
        <h5 id="historia">Historial</h5>
        <table className="table table-borderless">
            <thead className="thead-light">
                <tr>
                    {permisoIDSE && <th scope="col" style={{ width: '5%' }}>ESTATUS</th>}

                    {permisoHistorialOcultar && (
                        <>
                            <th scope="col"style={{ width: '20%' }}>FECHA</th>
                            <th scope="col">MOTIVO</th>
                            <th scope="col" style={{ width: '25%' }}>JEFE INMEDIATO</th>
                            <th scope="col" style={{ width: '25%' }}>RECLUTADOR</th>
                            <th scope="col" style={{ width: '25%' }}>GESTOR DE OPERADORES</th>
                            <th scope="col"style={{ width: '20%' }}>UDN</th>
                            <th scope="col"style={{ width: '20%' }}>CAUSA</th>
                            <th scope="col"style={{ width: '20%' }}>COMENTARIOS</th>
                        </>
                    )}

                    {permisoIDSE && <th scope="col" style={{ width: '30%' }}>IDSE</th>}
                </tr>
            </thead>
            <tbody>
                {historial?.map((item, index) => (
                    <tr key={index}>
                        {permisoIDSE && <td className="input">{item.tipo}</td>}

                        {permisoHistorialOcultar && (
                            <>
                                <td className="input"><DateFormatter value={item.fecha} /></td>
                                <td className="input">{item.motivo}</td>
                                <td className="input">{item.jefeInmediatoHistorial?.nombre}</td>
                                <td className="input">{item.reclutadorHistorial?.nombre}</td>
                                <td className="input">{item.gestorOperadoresHistorial?.nombre}</td>
                                <td className="input">{item.unidadNegocioHistorial?.nombre}</td>
                                <td className="input">{item.causa}</td>
                                <td className="input">{item.comentarios}</td>
                            </>
                        )}

                        {permisoIDSE && (
                            <td className="input">
                                <InputFile
                                    name="anexo"
                                    value={item.anexo}
                                    errors={errors[`historial[${index}]`]}
                                    disabled={soloLectura && !permisoHistorialEmpleados}
                                    onChange={(value, pName) =>
                                        actualizarLista(historial, index, value, pName, "historial")
                                    }
                                />
                            </td>
                        )}
                    </tr>
                ))}
            </tbody>
        </table>
    </>
)}



            <h5>Antidoping</h5>
            <table className="table table-borderless">
                <thead className="thead-light">
                    <tr>
                        <th scope="col" style={{ width: '20%' }}>FECHA</th>
                        <th scope="col" style={{ width: '20%' }}>Tipos de reactivos</th>
                        <th scope="col" style={{ width: '20%' }}>RESULTADO</th>
                        <th scope="col" style={{ width: '20%' }} />
                        <th
                   scope="col"
                            style={{
                                width: "10%",
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                verticalAlign: "middle",
                            }}
                        >ANEXO</th>
                        <th  style={{ width: '10%' }}>
                            {(!soloLectura || permisoHistorialEmpleados) &&
                                <ButtonIcon title={'Agregar Ruta'} iconName={'SiAddthis'} className="grid-action"
                                    onClick={() => agregarALista(antidoping, "antidoping")} />
                            }
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {antidoping?.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td className="input">
                                    <FieldCalendar name="fecha"
                                        className="small"
                                        value={item.fecha}
                                        showButtonBar={false}
                                        errors={errors[`antidoping[${index}]`]}
                                        onChange={(value, pName) => actualizarLista(antidoping, index, value, pName, "antidoping")} />
                                </td>
                                <td className="input">
                                    <FieldDropDown name="tiposDeReactivosId" source="tiposDeReactivos"
                                        value={item.tiposDeReactivosId}
                                        errors={errors[`antidoping[${index}]`]}
                                        onChange={(value, pName) => actualizarLista(antidoping, index, value, pName, "antidoping")} />
                                </td>
                                <td className="input">
                                    <FieldDropDown name="resultado" source="resultadosAntidoping"
                                        value={item.resultado}
                                        errors={errors[`antidoping[${index}]`]}
                                        onChange={(value, pName) => actualizarLista(antidoping, index, value, pName, "antidoping")} />
                                </td>
                                <td className="input">
                                    {item.resultado?.id === constantes.resultado.positivo &&
                                        <FieldMultiSelect name="examenPositivo"
                                            source="tiposAntidoping"
                                            value={item.examenPositivo}
                                            valueAsId={true}
                                            maxSelectedLabels={2}
                                            errors={errors[`antidoping[${index}]`]}
                                            onChange={(value, pName) => actualizarLista(antidoping, index, value, pName, "antidoping")} />
                                    }
                                </td>
                                <td className="input center">
                                    <InputFile name="anexo" value={item.anexo} errors={errors[`antidoping[${index}]`]} disabled={soloLectura && !permisoHistorialEmpleados}
                                        onChange={(value, pName) => actualizarLista(antidoping, index, value, pName, "antidoping")} />
                                </td>
                                <td className="input">
                                    {(!soloLectura || permisoHistorialEmpleados) &&
                                        <ButtonIcon title={'Eliminar'}
                                            onClick={() => eliminarDeLista(antidoping, index, "antidoping")}
                                            iconName={'RiDeleteBinLine'} />
                                    }
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>

            
            <h5>Antidoping Externo</h5>
            <table className="table">
                <thead className="thead-light">
                    <tr>
                        <th scope="col" style={{ width: '20%' }}>FECHA</th>
                        <th scope="col" style={{ width: '20%' }}>Nombre</th>
                        <th scope="col" style={{ width: '20%' }}>Tipos de reactivos</th>
                        <th scope="col" style={{ width: '20%' }}>RESULTADO</th>
                        <th scope="col" style={{ width: '20%' }} />
                        <th scope="col" className="center" style={{ width: '10%' }}>ANEXO</th>
                        <th style={{ width: '10%' }}>
                            {(!soloLectura || permisoHistorialEmpleados) &&
                                <ButtonIcon title={'Agregar Ruta'} iconName={'SiAddthis'} className="grid-action"
                                    onClick={() => agregarALista(antidopingExterno, "antidopingExterno")} />
                            }
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {antidopingExterno?.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td className="input">
                                    <FieldCalendar name="fecha"
                                        className="small"
                                        value={item.fecha}
                                        showButtonBar={false}
                                        errors={errors[`antidopingExterno[${index}]`]}
                                        onChange={(value, pName) => actualizarLista(antidopingExterno, index, value, pName, "antidopingExterno")} />
                                </td>
                                <td className="input">
                                            <FieldTextBox name="nombre" errors={errors[`antidopingExterno[${index}]`]} value={item.nombre}
                                                onChange={(value, pName) => actualizarLista(antidopingExterno, index, value, pName, "antidopingExterno")} />
                                </td>
                                <td className="input">
                                    <FieldDropDown name="tiposDeReactivosId" source="tiposDeReactivos"
                                        value={item.tiposDeReactivosId}
                                        errors={errors[`antidopingExterno[${index}]`]}
                                        onChange={(value, pName) => actualizarLista(antidopingExterno, index, value, pName, "antidopingExterno")} />
                                </td>
                                <td className="input">
                                    <FieldDropDown name="resultado" source="resultadosAntidoping"
                                        value={item.resultado}
                                        errors={errors[`antidopingExterno[${index}]`]}
                                        onChange={(value, pName) => actualizarLista(antidopingExterno, index, value, pName, "antidopingExterno")} />
                                </td>
                                <td className="input">
                                    {item.resultado?.id === constantes.resultado.positivo &&
                                        <FieldMultiSelect name="examenPositivo"
                                            source="tiposAntidoping"
                                            value={item.examenPositivo}
                                            valueAsId={true}
                                            maxSelectedLabels={2}
                                            errors={errors[`antidopingExterno[${index}]`]}
                                            onChange={(value, pName) => actualizarLista(antidopingExterno, index, value, pName, "antidopingExterno")} />
                                    }
                                </td>
                                <td className="input center">
                                    <InputFile name="anexo" value={item.anexo} errors={errors[`antidopingExterno[${index}]`]} disabled={soloLectura && !permisoHistorialEmpleados}
                                        onChange={(value, pName) => actualizarLista(antidopingExterno, index, value, pName, "antidopingExterno")} />
                                </td>
                                <td className="input">
                                    {(!soloLectura || permisoHistorialEmpleados) &&
                                        <ButtonIcon title={'Eliminar'}
                                            onClick={() => eliminarDeLista(antidopingExterno, index, "antidopingExterno")}
                                            iconName={'RiDeleteBinLine'} />
                                    }
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>


            <h5>Recurso Confiable</h5>
            <table className="table">
                <thead className="thead-light">
                    <tr>
                        <th scope="col" style={{ width: '40%' }}>TIPO</th>
                        <th scope="col" style={{ width: '35%' }}>VIGENCIA</th>
                        <th scope="col" className="center" style={{ width: '15%' }}>ARCHIVO</th>
                        <th style={{ width: '10%' }}>
                            {(!soloLectura || permisoHistorialEmpleados) &&
                                <ButtonIcon title={'Agregar Ruta'} iconName={'SiAddthis'} className="grid-action"
                                    onClick={() => agregarALista(recursosConfiables, "recursosConfiables")} />
                            }
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {recursosConfiables?.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td className="input">
                                    <FieldDropDown name="tipo" source="general/Tipo Recurso Confiable"
                                        value={item.tipo}
                                        errors={errors[`recursosConfiables[${index}]`]}
                                        onChange={(value, pName) => actualizarLista(recursosConfiables, index, value, pName, "recursosConfiables")} />
                                </td>
                                <td className="input">
                                    <FieldCalendar name="fecha"
                                        className="small"
                                        value={item.fecha}
                                        showButtonBar={false}
                                        errors={errors[`recursosConfiables[${index}]`]}
                                        onChange={(value, pName) => actualizarLista(recursosConfiables, index, value, pName, "recursosConfiables")} />
                                </td>
                                <td className="input center">
                                    <InputFile name="anexo" value={item.anexo} errors={errors[`recursosConfiables[${index}]`]} disabled={soloLectura && !permisoHistorialEmpleados}
                                        onChange={(value, pName) => actualizarLista(recursosConfiables, index, value, pName, "recursosConfiables")} />
                                </td>
                                <td className="input">
                                    {(!soloLectura || permisoHistorialEmpleados) &&
                                        <ButtonIcon title={'Eliminar'}
                                            onClick={() => eliminarDeLista(recursosConfiables, index, "recursosConfiables")}
                                            iconName={'RiDeleteBinLine'} />
                                    }
                                </td>
                            </tr>
                        )
                    }



                    )}

                </tbody>
            </table>

            {(permisoActasAdministrativas &&
                <>
                    <h5>Actas Administrativas</h5>
                    <table className="table">
                        <thead className="thead-light">
                            <tr>
                                <th scope="col" style={{ width: '20%' }}>FECHA</th>
                                <th scope="col" style={{ width: '25%' }}>MOTIVO</th>
                                <th scope="col" style={{ width: '35%' }}>COMENTARIO </th>
                                <th scope="col" className="center" style={{ width: '10%' }}>ANEXO</th>
                                <th style={{ width: '10%' }}>
                                    {(!soloLectura || permisoHistorialEmpleados) &&
                                        <ButtonIcon title={'Agregar Ruta'} iconName={'SiAddthis'} className="grid-action"
                                            onClick={() => agregarALista(actasAdministrativas, "actasAdministrativas")} />
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {actasAdministrativas?.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td className="input">
                                            <FieldCalendar name="fecha"
                                                className="small"
                                                value={item.fecha}
                                                showButtonBar={false}
                                                errors={errors[`actasAdministrativas[${index}]`]}
                                                onChange={(value, pName) => actualizarLista(actasAdministrativas, index, value, pName, "actasAdministrativas")} />
                                        </td>
                                        <td className="input">
                                            <FieldDropDown name="motivo" source="general/Motivo acta administrativa"
                                                value={item.motivo}
                                                errors={errors[`actasAdministrativas[${index}]`]}
                                                onChange={(value, pName) => actualizarLista(actasAdministrativas, index, value, pName, "actasAdministrativas")} />
                                        </td>
                                        <td className="input">
                                            <FieldTextBox name="comentarios" errors={errors[`actasAdministrativas[${index}]`]} value={item.comentarios}
                                                onChange={(value, pName) => actualizarLista(actasAdministrativas, index, value, pName, "actasAdministrativas")} />
                                        </td>
                                        <td className="input center">
                                            <InputFile name="anexo" value={item.anexo} errors={errors[`actasAdministrativas[${index}]`]} disabled={soloLectura && !permisoHistorialEmpleados}
                                                onChange={(value, pName) => actualizarLista(actasAdministrativas, index, value, pName, "actasAdministrativas")} />
                                        </td>
                                        <td className="input">
                                            {(!soloLectura || permisoHistorialEmpleados) &&
                                                <ButtonIcon title={'Eliminar'}
                                                    onClick={() => eliminarDeLista(actasAdministrativas, index, "actasAdministrativas")}
                                                    iconName={'RiDeleteBinLine'} />
                                            }
                                        </td>
                                    </tr>
                                )
                            }



                            )}

                        </tbody>
                    </table>
                </>
            )}

            <h5>Bitacora de Viaje</h5>
            <table className="table">
                <thead className="thead-light">
                    <tr>
                        <th>Descipcion</th>
                        <th>Vigencia</th>
                        <th style={{ width: '10%' }}>
                            {(!soloLectura || permisoHistorialEmpleados) &&
                                <ButtonIcon title={'Agregar Bitacora'} iconName={'SiAddthis'} className="grid-action"
                                    onClick={agregarBitacora} />
                            }
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {bitacora?.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>{item?.descripcion}</td>
                                <td>{moment(item?.vigencia).format('DD/MM/yyyy')}</td>
                                <td className="input">
                                    {(!soloLectura || permisoHistorialEmpleados) && item?.id === 0 &&
                                        <ButtonIcon title={'Eliminar'}
                                            onClick={() => eliminarDeLista(bitacora, index, "empleadoBitacoras")}
                                            iconName={'RiDeleteBinLine'} />
                                    }
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </ReadOnlyProvider>
    )
};

export default Historial;